import styled from "styled-components"
import {Label} from "@irati/ui/src/Typography"

import {PADDING} from "../constants"

interface StyledProps {
  size: number
}

const Text = styled<StyledProps>(Label)`
  position: absolute;
  ${({size}) => `
    top: ${(size - PADDING) / 2}px;
  `}
  left: 0;
  right: 0;
`

export default Text
